/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { mobileOrderConfirmationRequestSchema } from "./mobileOrderConfirmationRequestSchema.ts";

export const orgUnitConfirmOrderCreatePathOrgUnitIdSchema = z.uuid();

export const orgUnitConfirmOrderCreateStatus200Schema = z.any();

export const orgUnitConfirmOrderCreateResponseSchema = orgUnitConfirmOrderCreateStatus200Schema;

export const orgUnitConfirmOrderCreateDataSchemaJson = mobileOrderConfirmationRequestSchema;

export const orgUnitConfirmOrderCreateDataSchemaXml = mobileOrderConfirmationRequestSchema;

export const orgUnitConfirmOrderCreateDataSchema = z.union([orgUnitConfirmOrderCreateDataSchemaJson, orgUnitConfirmOrderCreateDataSchemaXml]);
